import React from 'react';

import * as s from './PageWithSidebar.css';

interface IPageLayoutWithSidebarParams {
  body: React.ReactNode;
  header?: React.ReactNode;
  children?: React.ReactNode;
}

/**
 * Шаблон страницы с сайдбаром
 */
export const PageWithSidebar = ({ body, header, children }: IPageLayoutWithSidebarParams) => (
  <>
    {header && <div className={s['header']}>{header}</div>}

    <div className={s['wrapper']}>
      <div className={s['body']}>{body}</div>
      {children && <div className={s['sidebar']}>{children}</div>}
    </div>
  </>
);
